import Toggle from "../classes/toggle";

export default class TeamCards {
    static init() {
        return new TeamCards();
    }

    constructor() {
        const teamCards = document.querySelectorAll('.cards-team .card-team');
        if (teamCards.length === 0) return;

        teamCards.forEach((teamCard) => {
            const button = teamCard.querySelector('a.team-show-more-info');

            const toggleButton = new Toggle(button, () => {
                teamCard.classList.toggle('collapsed');
            });
        });
    }
}
